import {ReactElement} from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Cable, CableManufacturer} from 'interfaces/Project';
import SelectCable from './components/SelectCable';

type Props = {
  defaultManufacturer?: string;
  onCableSelect: (cable: Cable) => void;
  manufacturers: [CableManufacturer, ...CableManufacturer[]];
  opened: boolean;
  onOpenClicked: () => void;
  onCloseClicked: () => void;
};

export default function AddCableDialogView({
  defaultManufacturer,
  opened,
  onOpenClicked,
  onCloseClicked,
  onCableSelect,
  manufacturers
}: Props): ReactElement {
  const {t} = useTranslation('common');

  return (
    <>
      <Button
        endIcon={<AddIcon />}
        onClick={onOpenClicked}
        variant="outlined"
        color="inherit"
        sx={{flexShrink: 0, color: 'ctaDark', borderColor: 'borderColorStrong'}}
      >
        {t('common:addCable')}
      </Button>
      <Dialog
        onClose={onCloseClicked}
        open={opened}
        fullWidth
        maxWidth={false}
        PaperProps={{sx: {maxWidth: 1100}}}
      >
        <DialogTitle component="div" sx={{p: 0}}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
              p: 3
            }}
          >
            <Typography sx={{fontSize: 24, fontWeight: 400, color: 'ctaBlack'}}>
              {t('common:selectCable')}
            </Typography>
            <IconButton aria-label="close" onClick={onCloseClicked} sx={{color: 'ctaBlack'}}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <SelectCable
            defaultManufacturer={defaultManufacturer}
            manufacturers={manufacturers}
            onCableSelect={onCableSelect}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
